export default __webpack_public_path__ + "static/media/r8.e8a44bc4.jpg";